import React from 'react';

import winningDecoration from '../../common/svg/bid/winner_decorations.svg';
import styles from './Auction.module.css';
import { BidSchedule } from './bid-schedule';
import { LiveStreamCard } from './card/LiveStreamCard.component';
import type { NFTCardProps } from './card/NFTCard.component';
import { NFTCard } from './card/NFTCard.component';
import { WinnerInfo } from './winner-info';

export interface AuctionComponentProps extends NFTCardProps {
  hasGasPrompt?: boolean;
  livestream?: {
    link: string;
    title: string;
    description: string;
  };
  startDate: Date;
  isHighestBidder: boolean;
}

export const AuctionComponent: React.FC<AuctionComponentProps> = props => {
  const {
    livestream,
    startDate,
    endDate,
    hasGasPrompt,
    isLive,
    hasEnded,
    ...nftProps
  } = props;

  // TODO: fix winner and currentbid prop in AuctionPage.container.tsx and remove hard coded values here
  return (
    <div className={styles.AuctionComponent}>
      <div className={styles.auctionHeaderContainer}>
        <div className={styles.auctionMainHeaderContainer}>
          <div className={styles.auctionHeaderSpecial}>
            <div className={styles.auctionHeader}>proof</div>
            <div className={styles.auctionSubHeader}>with rob prior </div>
          </div>
          <div className={styles.auctionHeader}>
            <span className={styles.auctionSmallerHeader}>of</span>origin
          </div>
        </div>
        <div className={styles.auctionDescriptionContainer}>
          <BidSchedule
            startDate={props.startDate}
            hasEnded={hasEnded}
            isLive={isLive}
          />
        </div>
      </div>
      {/** @todo */}
      <WinnerInfo
        hasEnded={hasEnded}
        currentBid=""
        winner=""
        decoration={winningDecoration}
      />
      {Boolean(livestream) && (
        <div className={styles.livestreamContainer}>
          <LiveStreamCard
            livestream={livestream!.link}
            title={livestream!.title}
            description={livestream!.description}
          />
        </div>
      )}
      <div className={styles.nftCardContainer}>
        <NFTCard
          {...nftProps}
          currentBid={'5500000'}
          winner="0xBEBEEf2B9D52bf04685d1b61BA5b01aCFaE409e3"
          isLive={isLive}
          hasEnded={hasEnded}
          endDate={endDate}
        />
        {props.isHighestBidder && props.isLive && (
          <div className={styles.highestBidderIndication}>
            you currently hold the highest bid
          </div>
        )}
      </div>
    </div>
  );
};
